export function clickFirst(wrapper, className) { wrapper.find(className).first().simulate('click') }

export function simulateChangeValue(wrapper, className, value) { wrapper.find(className).first().simulate('change', { target: { value } }) }
